import React from 'react';
import { type RouterSpecsFragment } from '../../../api/fragments';
import LayoutActions from './Layout/LayoutActions';
import RouterMenuActions from './menuItems/RouterMenuActions';

type Props = { activeTab: string; router: RouterSpecsFragment };

const RouterDetailsFooter = ({ activeTab, router }: Props) => {
    if (activeTab === 'endpoints') {
        return null;
    }

    if (activeTab === 'layout') {
        return <LayoutActions router={router} />;
    }

    if (activeTab === 'menu') {
        return <RouterMenuActions />;
    }

    return null;
};

export default RouterDetailsFooter;
